import { theme } from "@op-str/op-component-library"
import React from "react"
import styled from "styled-components"
import { ButterCmsErrorBoundary } from "../ButterCmsErrorBoundary"
import { HorizontalLine } from "../HorizontalLine"
import { HtmlContainer } from "../HtmlContainer"
import { NarrowPageContent } from "../NarrowPageContent"
import { ExpandItem } from "./ExpandItem"

export type ExpandProps = {
  sectionTitle?: string
  items?: {
    expand_item_content: string
    expand_item_title: string
  }[]
  bottomLink?: string
  className?: string
}

const COMPONENT_NAME = "Expand"

export const Expand = (props: ExpandProps) => {
  const { sectionTitle, items, bottomLink, className } = props

  return (
    <ButterCmsErrorBoundary componentName={COMPONENT_NAME}>
      <Root className={className}>
        <NarrowPageContent>
          <SectionTitle>{sectionTitle}</SectionTitle>
          {!!items && (
            <>
              <HorizontalLine />
              {items.map((item, index) => (
                <div key={index}>
                  <ExpandItem title={item.expand_item_title} content={item.expand_item_content} />
                  <HorizontalLine />
                </div>
              ))}
              <VerticalSpace />
            </>
          )}
          {!!bottomLink && <HtmlContainerWithPadding dangerouslySetInnerHTML={{ __html: bottomLink }} />}
        </NarrowPageContent>
      </Root>
    </ButterCmsErrorBoundary>
  )
}

const Root = styled.div`
  margin-top: 75px;
  width: 100%;
  background-color: ${theme.color.white2};
`

const SectionTitle = styled.div`
  padding: 48px 0 30px 0;
  font-size: 20px;
  font-family: ${theme.font.bold};
`

const VerticalSpace = styled.div`
  height: 25px;
`

const HtmlContainerWithPadding = styled(HtmlContainer)`
  margin: 0;
  padding-bottom: 60px;
`
